import { useState, useCallback } from 'react'
import { observer } from 'mobx-react-lite'
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  useTheme,
} from '@mui/material'
import { Menu, Sort, MenuOpen } from '@mui/icons-material'
import SortMenu from '../../features/list-sorting/ui/SortMenu'
import { useStores } from '../../app/providers/withStore'

const Header = observer(({ handleDrawerToggle }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const { layoutStore } = useStores()
  const theme = useTheme()

  const clickDropSortHandler = useCallback((event) => {
    setAnchorEl(event.currentTarget)
  }, [])

  const closeDropSortHandler = useCallback(() => {
    setAnchorEl(null)
  }, [])

  return (
    <AppBar
      position="sticky"
      color="transparent"
      elevation={0}
      sx={{
        backdropFilter: 'blur(8px)',
        backgroundColor:
          theme.palette.mode === 'light'
            ? 'rgba(255, 255, 255, 0.8)'
            : 'rgba(30, 30, 30, 0.8)',
        // The header should be above the sidebar on mobile
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar>
        {/* Left side controls */}
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
          <IconButton
            color="primary"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { md: 'none' } }}
          >
            <Menu />
          </IconButton>
          <IconButton
            onClick={layoutStore.toggleMini}
            sx={{ display: { xs: 'none', md: 'inline-flex' } }}
          >
            {layoutStore.isMini ? <Menu /> : <MenuOpen />}
          </IconButton>
        </Box>

        {/* Centered Title */}
        <Typography
          variant="h6"
          component="div"
          noWrap
          sx={{ flexGrow: 1, textAlign: 'center', minWidth: 0 }}
        >
          {layoutStore.headerConfig.title}
        </Typography>

        {/* Right side controls */}
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
          {layoutStore.headerConfig.customActions}
          {layoutStore.headerConfig.showSortButton ? (
            <IconButton onClick={clickDropSortHandler}>
              <Sort color="primary" />
            </IconButton>
          ) : (
            !layoutStore.headerConfig.customActions && (
              <Box sx={{ width: 48 }} />
            )
          )}
          <SortMenu anchorEl={anchorEl} handleClose={closeDropSortHandler} />
        </Box>
      </Toolbar>
    </AppBar>
  )
})

export default Header
